"use client";
import { ButtonComponent, LoaderComponent } from "@/components";
import { BankVarificationModal } from "@/components/Modals/BankVarificationModal";
import { useRouter } from "@/i18n/routing";
import {
  GET_PRODUCT_APPLICATION,
  IMAGES,
  PRODUCT_HANDLER,
  PRODUCTS,
  STAGE,
  STAGE_BASED_ROUTING,
  SUBSTAGE,
  WEB_COLORS,
  WEB_EVENTS,
} from "@/lib/constants";
import ENV from "@/lib/constants/EnvVariables";
import { useFooter } from "@/lib/context/FooterContext";
import useErrorHandling from "@/lib/hooks/errorhandling";
import { sendEventAnalytics } from "@/lib/hooks/eventAnalytics";
import useStageErrorHandler from "@/lib/hooks/stageErrorHandler";
import {
  useGetApplicationQuery,
  useGetCustomerQuery,
  useGetOffersQuery,
  useSelectedOfferTenureMutation,
  useUpdateInsuranceMutation,
  useUpdateOfferMutation,
} from "@/lib/redux";
import { setLocation, setOfferSelectedData } from "@/lib/redux/slice";
import { setSelectedPlans } from "@/lib/redux/slice/InsuranceSlice";
import FaceVerificationModal from "@/screens/product-screens/kyc/face-verification/face-verification-modal";
import InsurancePlan from "@/screens/protection-plans";
import {
  Box,
  Container,
  Icon,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import RecommendedOffer from "./offer-recommended";
import UnlockOfferBanner from "./unlock-offer/upto-5";
import { setModalAttributes } from "@/lib/redux/slice/ModalSlice";
import UpgradeOfferPopup from "./offer-popup";
import UpgradeOfferUpto7 from "./unlock-offer/upto-7";
import { checkForRpl, checkForRplProductRoute } from "@/lib/utils/rpl.utils";
import { sessionStorageUtil } from "@/lib/utils/common.utils";
import { InfoOutlined } from "@mui/icons-material";
// import OfferLoader from "./offer-loader-screen";
import OfferVerificationLoader from "./offer-loader-screen";

const POLLING_INTERVAL = 20000;
// max bre offer polling count
const MAX_OFFER_COUNT = 5;
const pirmidError = [
  `Bank chosen is your Salary A/C, or if your salary bank is not listed, then select your bank with most transactions.`,
  `The company name mentioned is as per payslip.`,
  `Your Bank A/C is more than 6 months old.`,
];
const MAX_CALLBACK_POLLING_COUNT = 3;

const AA_CUM_PERFIOS_MAX_LIMIT = ENV.AA_CUM_PERFIOS_MAX_LIMIT;

const OfferScreen = ({ product }) => {
  const t = useTranslations("offers");
  const router = useRouter();
  const dispatch = useDispatch();
  const theme = useTheme();
  const params = new URLSearchParams();

  const productType = useSelector((s) => s.applicationSlice.productType);

  const { offerSelectedData } = useSelector((s) => s.offerselection);
  const [count, setCount] = useState(0);
  const [showErrorFaceMatchModal, setShowErrorFaceMatchModal] = useState(false);
  const [bankValidationModal, setBankValidationModal] = useState({
    open: false,
    error: "",
  });
  const [showModalContent, setShowModalContent] = useState({
    label:
      "Sorry! We cannot proceed with your Application, We would love to serve you in the future, please re-apply after 30 days.",
    subLabel: "Sorry! Please try again later",
    buttonLabel: "OK",
    icon: IMAGES.faceNotVerified,
  });
  const [loader, setLoader] = useState(true);
  const [acceptOfferLoader, setAcceptOfferLoader] = useState(false);
  const [pollingInterval, setPollingInterval] = useState(POLLING_INTERVAL);
  const [recommendedOffer, setRecommendedOffer] = useState(null);
  const [editOffer, setEditOffer] = useState(false);
  const [offerReminder, setOfferReminder] = useState(false);
  const { setActions } = useFooter();
  const [openUpgradeOffer, setOpenUpgradeOffer] = useState(false);

  const [callbackPollingCount, setCallbackPollingCount] = useState(0);
  const [callbackLoader, setCallbackLoader] = useState(false);
  const [isCallbackPollingActive, setIsCallbackPollingActive] = useState(false);
  const [showRetryError, setShowRetryError] = useState(false);

  const { insuranceDeclaration, insuranceSelected, selectedPlans, totalPlans } =
    useSelector((s) => s.insurance);

  const effectivePollingInterval =
    isCallbackPollingActive || showRetryError ? 0 : pollingInterval;
  /*******************************RTK QUERY*******************************/
  const {
    data: applicationData,
    isLoading: fetchingApplications,
    error: applicationFetchError,
    refetch: refetchApplicationData,
  } = useGetApplicationQuery("", {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
  });
  const { data: customerData } = useGetCustomerQuery();
  const [
    updateOffer,
    {
      data: updateOfferData,
      error: errorUpdateOffer,
      isLoading: UpdateOfferLoading,
    },
  ] = useUpdateOfferMutation();
  //API COMMON ENITITIES
  const productApplication = GET_PRODUCT_APPLICATION(
    PRODUCT_HANDLER[productType],
    applicationData?.data,
  );

  const isRPL = checkForRpl(productApplication);
  var {
    data: offersData,
    error: errorOffers,
    isLoading: loadingOffers,
    refetch: refetchOffer,
    isFetching: isfetchingOffer,
  } = useGetOffersQuery(
    {
      appId: productApplication?.appId,
      isRPL,
    },
    {
      skip: !productApplication?.appId,
      pollingInterval: effectivePollingInterval,
      refetchOnFocus:
        !loader &&
        !callbackLoader &&
        !isCallbackPollingActive &&
        !showRetryError,
    },
  );

  const [
    insuranceUpdate,
    {
      data: insuranceUpdateData,
      isLoading: loadingInsuranceUpdateData,
      error: insuranceUpdateDataError,
    },
  ] = useUpdateInsuranceMutation();
  const [
    selectedOfferTenure,
    {
      data: selectedOfferTenureData,
      error: errorSelectedOfferTenure,
      isLoading: selectedOfferTenureLoading,
    },
  ] = useSelectedOfferTenureMutation();
  const isError =
    applicationFetchError ||
    errorOffers ||
    errorUpdateOffer ||
    errorSelectedOfferTenure ||
    insuranceUpdateDataError;

  /*******************************ACTION*******************************/
  const refreshbtn = async () => {
    const callbackStatus = offersData?.data?.callbackInitiated;
    if (callbackStatus) {
      // setCallbackLoader(false);
      // setIsCallbackPollingActive(false);
      setCallbackPollingCount(0);
    }

    setShowRetryError(false);
    await refetchApplicationData();
    setPollingInterval(POLLING_INTERVAL);
    setCount(0);
    refetchOffer();
  };

  const handleUnlockNow = () => {
    if (callbackLoader) return;
    sendEventAnalytics({
      eventName: WEB_EVENTS.UNLOCK_OFFER_SELECTED,
      ...productApplication,
      ...customerData?.data,
    });
    dispatch(setLocation("offer"));
    navigateToUnlockLoan();
  };

  const getOfferUpgrade = () => {
    if (offersData?.data?.bre2Popup) return 5;
    if (offersData?.data?.topUpOffer) return 7;

    return null;
  };

  const navigateToUnlockLoan = () => {
    const isSalaried =
      productApplication?.employmentType?.toLowerCase() === "salaried";

    if (!isSalaried) {
      router.push("/personal-loan/unlock-loan");
      return;
    }

    const params = new URLSearchParams();
    const offerUpgrade = getOfferUpgrade();

    if (offerUpgrade) {
      params.set("offerUpgrade", String(offerUpgrade));
    }

    const queryString = params.toString();

    router.push(
      `/personal-loan/unlock-loan/salaried${
        queryString ? `?${queryString}` : ""
      }`,
    );
  };

  const cibilLoaderSubstages = [
    SUBSTAGE.HUNTER_ACCEPTED,
    SUBSTAGE.UCIC_REQUEST_ACCEPT,
    SUBSTAGE.BUREAU_REQUEST_ACCEPT,
    SUBSTAGE.LAT_LONG_ACCEPT,
    SUBSTAGE.POLICY_SKIPPED,
  ];
  /*******************************EFFECT*******************************/

  useEffect(() => {
    if (
      loadingOffers &&
      STAGE.OFFERS === productApplication?.stage &&
      cibilLoaderSubstages.includes(productApplication?.subStage)
    ) {
      setLoader(true);
    }
  }, [loadingOffers, productApplication?.stage, productApplication?.subStage]);
  
  useEffect(() => {
    setCount(0);
    const isRPL = checkForRplProductRoute(product);
    sendEventAnalytics({
      eventName: WEB_EVENTS.ON_OFFER_SCREEN,
      skip: isRPL,
      ...productApplication,
      ...customerData?.data,
    });
  }, []);
  useErrorHandling(isError);
  useStageErrorHandler({
    stage: productApplication?.stage,
    prevStage: productApplication?.previousStage,
    message: productApplication?.loanReapplyMessage,
  });

  const BANK_VERIFICATION_FAILED =
    productApplication?.subStage === SUBSTAGE.AA_PIRMID_DATA_NOT_AVAILABLE ||
    ((productApplication?.subStage === SUBSTAGE.AA_PIRMID_FAILED ||
      productApplication?.subStage === SUBSTAGE.AA_CALLBACK_TIMEOUT) &&
      productApplication?.aaReason === "CONSENT_REJECTED");

  useEffect(() => {
    if (!productApplication) {
      refetchApplicationData();
      return;
    }

    // closing application
    const subStageFails = [
      SUBSTAGE.PAN_CKYC_FAIL,
      SUBSTAGE.PAN_CKYC_NAME_MATCH_CREDIT_QUEUE,
      SUBSTAGE.PAN_CKYC_NAME_MATCH_REJECTED,
      SUBSTAGE.DIGI_KYC_FAIL,
      SUBSTAGE.PAN_AADHAR_MISMATCH,
      SUBSTAGE.PAN_DOB_MISMATCH,
      SUBSTAGE.CREDIT_DECISION_NAME_MISMATCH,
    ];
    if (subStageFails.includes(productApplication?.subStage)) {
      dispatch(
        setModalAttributes({
          open: true,
          message: productApplication?.loanReapplyMessage
            ? productApplication?.loanReapplyMessage
            : `Sorry! We are unable to continue your loan application. Please re-apply on ${productApplication?.loanApplyDate}`,
          type: STAGE.CLOSED,
        }),
      );
      // setLoader(false);
      // setShowErrorFaceMatchModal(true);
      // setShowModalContent({
      //   label: productApplication?.loanReapplyMessage
      //     ? productApplication?.loanReapplyMessage
      //     : `Sorry! We are unable to continue your loan application. Please re-apply on ${productApplication?.loanApplyDate}`,
      //   subLabel:
      //     productApplication?.loanApplyDate !== null ? "" : "Please try later",
      //   buttonLabel: "OK",
      //   icon: IMAGES.rejectedLoan,
      // });
      return;
    }
    const bankingErrorPopup = sessionStorageUtil.get("bankingErrorPopup");
    const callbackStatus =
      offersData?.data?.callbackInitiated &&
      offersData?.data?.callbackInitiated !== "pending";

    if (!bankingErrorPopup && callbackStatus && BANK_VERIFICATION_FAILED) {
      setLoader(false);
      setShowErrorFaceMatchModal(true);
      if (AA_CUM_PERFIOS_MAX_LIMIT > productApplication?.aaCount) {
        setShowModalContent({
          label: `We could not verify your bank statement.`,
          subLabel: (
            <Stack>
              <Typography>Please Ensure:</Typography>
              <List>
                {pirmidError?.map((item, index) => (
                  <ListItem key={index}>
                    <ListItemIcon>
                      <Typography
                        variant="body2"
                        fontSize={{ xs: "12px", sm: "14px" }}
                      >
                        {index + 1}.
                      </Typography>
                    </ListItemIcon>
                    <ListItemText primary={item} />
                  </ListItem>
                ))}
              </List>
              <Box
                mt={1}
                display={"flex"}
                flexDirection={"row"}
                gap={0.5}
                alignItems={"center"}
                mb={1}
              >
                <InfoOutlined
                  color={WEB_COLORS.errorColor}
                  sx={{
                    color: WEB_COLORS.errorColor,
                    fontSize: { xs: "12px", sm: "14px" },
                  }}
                />

                <Typography
                  fontWeight={350}
                  fontSize={{ xs: "8px", sm: "16px" }}
                  color={WEB_COLORS.errorColor}
                >
                  {AA_CUM_PERFIOS_MAX_LIMIT - productApplication?.aaCount}{" "}
                  {AA_CUM_PERFIOS_MAX_LIMIT - productApplication?.aaCount > 1
                    ? "Attempts Remaining"
                    : "Attempt Remaining"}
                </Typography>
              </Box>
            </Stack>
          ),
          buttonLabel: "Retry Bank Verification",
          icon: IMAGES.bankVerificationError,
          error: productApplication?.aaPerfiosRetryAttemptMessage,
        });
      } else {
        setShowModalContent({
          label: `We could not verify your bank statement.`,
          buttonLabel: "Ok",
          icon: IMAGES.bankVerificationError,
          error: productApplication?.aaPerfiosRetryAttemptMessage,
        });
      }
      if (offersData?.data?.bureauSurrogate) {
        sessionStorageUtil.set("bankingErrorPopup", "Y");
      }
      return;
    }
    // aa/perfios failed
    if (
      [
        SUBSTAGE.AA_REQUEST_FAILED,
        SUBSTAGE.AA_WEB_REQUEST_URL_FAILED,
        SUBSTAGE.AA_FAILED_PERFIOS_INITIALTED,
        SUBSTAGE.PERFIOS_REQUEST_FAILED,
      ]?.includes(productApplication?.subStage)
    ) {
      setBankValidationModal({
        open: true,
        error: productApplication?.aaPerfiosRetryAttemptMessage,
      });
    }
  }, [productApplication, offersData?.data]);

  // useEffect(() => {
  //   const callbackStatus = offersData?.data?.callbackInitiated?.toLowerCase();
  //   if (
  //     callbackStatus === "pending" ||
  //     isCallbackPollingActive ||
  //     callbackLoader
  //   ) {
  //     return;
  //   }
  //   try {
  //     if (
  //       isfetchingOffer &&
  //       ((!offersData?.data && count <= MAX_OFFER_COUNT) ||
  //         offersData?.data?.offers?.length === 0) &&
  //       count <= MAX_OFFER_COUNT
  //     ) {
  //       setLoader(true);
  //       setTimeout(() => {
  //         setCount((prev) => prev + 1);
  //       }, 10000);
  //       return;
  //     } else if (
  //       (count >= MAX_OFFER_COUNT &&
  //         Object.entries(offersData?.data).length === 0) ||
  //       (count >= MAX_OFFER_COUNT && offersData?.data?.offers?.length === 0)
  //     ) {
  //       setCount(6);
  //       setPollingInterval(0);
  //       setLoader(false);
  //       return;
  //     } else if (count > MAX_OFFER_COUNT) {
  //       setCount(6);
  //       setPollingInterval(0);
  //       setLoader(false);
  //       return;
  //     } else {
  //       if (count === 0) {
  //         setLoader(true);
  //       }
  //       if (count >= MAX_OFFER_COUNT) {
  //         setPollingInterval(0);
  //         return;
  //       }
  //     }
  //   } catch (error) {
  //     setLoader(false);
  //   }
  // }, [isfetchingOffer, count]);

  useEffect(() => {
    const callbackStatus = offersData?.data?.callbackInitiated;

    if (!callbackStatus) return;

    if (callbackStatus === "pending") {
      setLoader(false);
      setCallbackLoader(true);

      if (callbackPollingCount < MAX_CALLBACK_POLLING_COUNT) {
        setIsCallbackPollingActive(true);
      } else {
        setIsCallbackPollingActive(false);
        setLoader(false);
        setCallbackLoader(false);
        setShowRetryError(true);
        setPollingInterval(0);
      }
      return;
    }

    if (callbackStatus && callbackStatus !== "pending") {
      setIsCallbackPollingActive(false);
      setCallbackLoader(false);
      setCallbackPollingCount(0);
      refetchApplicationData();
      setShowRetryError(false);
    }
  }, [offersData?.data?.callbackInitiated, callbackPollingCount]);

  useEffect(() => {
    if (!isCallbackPollingActive) return;

    const timer = setTimeout(async () => {
      try {
        await refetchOffer();
        setCallbackPollingCount((prev) => prev + 1);
      } catch (error) {
        console.error("Callback polling failed:", error);
        setIsCallbackPollingActive(false);
        setCallbackLoader(false);
      }
    }, POLLING_INTERVAL);

    return () => clearTimeout(timer);
  }, [isCallbackPollingActive, callbackPollingCount, refetchOffer]);

  useEffect(() => {
    if (updateOfferData?.data?.stage) {
      refetchApplicationData();
    }
  }, [updateOfferData]);

  useEffect(() => {
    window.history.pushState(
      { offerBackGuard: true },
      "",
      window.location.href,
    );

    const handleBrowserBack = () => {
      router.replace("/");
    };

    window.addEventListener("popstate", handleBrowserBack);

    return () => {
      window.removeEventListener("popstate", handleBrowserBack);
    };
  }, [router]);

  useEffect(() => {
    if (selectedOfferTenureData?.data?.stage) {
      refetchApplicationData();
    }
  }, [selectedOfferTenureData]);

  useEffect(() => {
    if (offersData?.data) {
      if (offersData?.data?.callbackInitiated?.toLowerCase() === "pending") {
        return;
      }
      if (
        offersData?.data?.offers?.length > 0 &&
        !offersData?.data?.retry &&
        offersData?.data?.decision === "Accept"
      ) {
        let newRecommendedOffer = offersData?.data?.offers?.filter(
          (val) => val?.offerType === "RECOMMENDED",
        )[0];
        if (!newRecommendedOffer) {
          newRecommendedOffer = offersData?.data?.offers[0];
        }
        dispatch(setOfferSelectedData(newRecommendedOffer));
        setLoader(false);
        setLoader(false);
        refetchApplicationData();
        setPollingInterval(0);
        setRecommendedOffer(newRecommendedOffer);
        if (offersData?.data?.topUpOffer) {
          const upgradeOfferPopup = localStorage.getItem("upgradeOfferPopup");
          setOpenUpgradeOffer(
            !upgradeOfferPopup && offersData?.data?.topUpOffer,
          );
        }
      } else if (
        offersData?.data?.offers?.length === 0 &&
        !offersData?.data?.retry &&
        offersData?.data?.decision === "Accept" &&
        !offersData?.data?.bureauSurrogate
      ) {
        if (!offersData?.data?.bre2Status) {
          setLoader(false);
          dispatch(setLocation(""));
          if (BANK_VERIFICATION_FAILED) {
            return;
          } else {
            navigateToUnlockLoan();
          }
        }
        setPollingInterval(0);
      } else if (
        !offersData?.data?.retry &&
        offersData?.data?.decision === "Reject"
      ) {
        refetchApplicationData();
        setLoader(false);
        setPollingInterval(0);
      }
      // else if (count >= 6 && offersData?.data?.retry) {
      //   refetchApplicationData();
      //   setLoader(false);
      // } else if (count > MAX_OFFER_COUNT) {
      //   setLoader(false);
      //   setPollingInterval(0);
      //   refetchApplicationData();
      // }
    }
    // else if (count > MAX_OFFER_COUNT) {
    //   setLoader(false);
    //   refetchApplicationData();
    // }
  }, [offersData, count, isfetchingOffer, isRPL]);

  useEffect(() => {
    if (
      productApplication?.subStage === "BRE2_AA_REJECT" ||
      productApplication?.subStage === "BRE2_AA_ACCEPT" ||
      productApplication?.subStage === "BRE2_PERFIOS_ACCEPT" ||
      productApplication?.subStage === "BRE2_PERFIOS_REJECT"
    ) {
      sendEventAnalytics({
        ...productApplication,
        ...customerData?.data,
        eventName: WEB_EVENTS.AA_REDIRECT_TO_APP,
      });
    }
  }, [productApplication?.subStage]);

  const handleEditOffer = () => {
    setEditOffer(!editOffer);
  };

  useEffect(() => {
    if (
      productApplication?.stage &&
      productApplication?.stage !== STAGE.OFFERS
    ) {
      router.push(STAGE_BASED_ROUTING(productApplication?.stage));
    }
  }, [productApplication?.stage]);

  useEffect(() => {
    setActions({
      showReject: false,
      showConfirm:
        offersData?.data?.offers?.length > 0 &&
        !editOffer &&
        offersData?.data?.callbackInitiated?.toLowerCase() !== "pending",
      onConfirm: insuranceSelected
        ? proceedWithSelection
        : handleLimitedOfferModal,
      confirmBtnLabel: "I Accept The Offer",
      disabledConfirmBtn: insuranceSelected && !insuranceDeclaration,
    });
  }, [
    setActions,
    productApplication,
    insuranceSelected,
    recommendedOffer,
    offersData,
    editOffer,
    insuranceDeclaration,
  ]);

  const handleLimitedOfferModal = () => {
    setOfferReminder((o) => !o);
  };

  const proceedWithSelection = async () => {
    try {
      const isRpl = checkForRpl(productApplication);
      setAcceptOfferLoader(true);

      sendEventAnalytics({
        eventName: isRpl
          ? WEB_EVENTS.RL_OFFER_ACCEPTED
          : WEB_EVENTS.SELECTED_LOAN_AMOUNT_AGREE,
        ...productApplication,
        ...customerData?.data,
      });
      sendEventAnalytics({
        eventName: WEB_EVENTS.OFFER_SCREEN_INSURANCE_OPTED,
        skip: isRpl,
        ...productApplication,
        ...customerData?.data,
      });

      const updateOfferTenure = {
        appId: productApplication?.appId,
        offerId: offerSelectedData?.id,
        newRequestLoanAmount: offerSelectedData?.amount.toString(),
        selectedTenure: parseInt(offerSelectedData?.tenure),
      };

      let insurancePayload;

      if (offerReminder) {
        const newSelectedPlans = Array.from(
          { length: totalPlans },
          (_, i) => i + 1,
        );

        insurancePayload = {
          appId: productApplication.appId,
          selectedPlan: newSelectedPlans,
          selectOfferRequest: {
            offerId: offerSelectedData?.id,
            newRequestLoanAmount: offerSelectedData?.amount,
            selectedTenure: offerSelectedData?.tenure,
          },
          insuranceConsent: false,
          isConsentRequest: false,
        };

        dispatch(setSelectedPlans(newSelectedPlans));
        setOfferReminder(false);
      } else {
        insurancePayload = {
          appId: productApplication.appId,
          selectedPlan: selectedPlans,
          selectOfferRequest: {
            offerId: offerSelectedData?.id,
            newRequestLoanAmount: offerSelectedData?.amount,
            selectedTenure: offerSelectedData?.tenure,
          },
          insuranceConsent: true,
          isConsentRequest: true,
        };
      }
      await insuranceUpdate(insurancePayload).unwrap();
      await selectedOfferTenure({ body: updateOfferTenure, isRPL });
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setAcceptOfferLoader(false);
      localStorage.removeItem("upgradeOfferPopup");
    }
  };
  const handleContinueWithoutInsurance = async () => {
    setOfferReminder(false);
    const isRpl = checkForRpl(productApplication);

    let updateOfferTenure = {
      appId: productApplication?.appId,
      offerId: offerSelectedData?.id,
      newRequestLoanAmount: (offerSelectedData?.amount).toString(),
      selectedTenure: parseInt(offerSelectedData?.tenure),
    };
    sendEventAnalytics({
      eventName: isRpl
        ? WEB_EVENTS.RL_OFFER_ACCEPTED
        : WEB_EVENTS.SELECTED_LOAN_AMOUNT_AGREE,
      ...productApplication,
      ...customerData?.data,
    });
    sendEventAnalytics({
      eventName: WEB_EVENTS.OFFER_SCREEN_INSURANCE_SKIPPED,
      skip: isRpl,
      ...productApplication,
      ...customerData?.data,
    });
    try {
      setAcceptOfferLoader(true);
      await selectedOfferTenure({ body: updateOfferTenure, isRPL }).unwrap();
      localStorage.removeItem("upgradeOfferPopup");
    } catch (err) {
      console.error(err);
      setAcceptOfferLoader(false);
    }
  };

  const handleContinueWithUpgrade = () => {
    if (callbackLoader) return;
    localStorage.setItem("upgradeOfferPopup", "N");
    sendEventAnalytics({
      eventName: WEB_EVENTS.UNLOCK_OFFER_SELECTED,
      ...productApplication,
      ...customerData?.data,
    });
    navigateToUnlockLoan();
  };

  const callbackStatus = offersData?.data?.callbackInitiated;
  const offers = offersData?.data?.offers || [];

  const isCallbackResolved =
    !callbackStatus || (callbackStatus && callbackStatus !== "pending");

  const canShowMainContent =
    !loader &&
    !callbackLoader &&
    !showRetryError &&
    offers.length > 0 &&
    isCallbackResolved;

  const canShowRefresh =
    callbackStatus &&
    !callbackLoader &&
    (showRetryError || (count > MAX_OFFER_COUNT && offers.length === 0));

  const navigateAfterBankVerification = () => {
    if (!BANK_VERIFICATION_FAILED) {
      router.push("/");
      return;
    }

    if (productApplication?.aaCount < AA_CUM_PERFIOS_MAX_LIMIT) {
      navigateToUnlockLoan();
    }
  };

  const handleVerificationModalClose = () => {
    setShowErrorFaceMatchModal(false);
    if (offersData?.data?.bureauSurrogate) {
      return;
    }
    navigateAfterBankVerification();
  };

  const handleVerificationModalAction = () => {
    setShowErrorFaceMatchModal(false);
    navigateAfterBankVerification();
  };

  const maskPAN = (pan) => {
    if (!pan) return "";
    return pan.slice(0, 5) + "*".repeat(Math.max(0, pan.length - 5));
  };
  const offerReady =
    offersData?.data?.offers?.length > 0 &&
    !offersData?.data?.retry &&
    offersData?.data?.decision === "Accept";

  /*******************************RENDER*******************************/
  return (
    <>
      {productApplication?.appId && loader && (
        <OfferVerificationLoader
          complete={offerReady}
          onComplete={() => {
            setLoader(false);
            refetchApplicationData();
          }}
          appId={productApplication?.appId}
          pan={maskPAN(productApplication?.panNumber)}
        />
      )}
      <LoaderComponent
        open={callbackLoader || acceptOfferLoader}
        loadingLabel={
          acceptOfferLoader
            ? productApplication?.stage === STAGE.OFFERS &&
              offersData?.data?.offers?.length === 0
              ? "Hang tight! We’ll notify you as soon as a loan offer is ready."
              : ""
            : ""
        }
        stage={productApplication?.stage}
      />
      {canShowMainContent ? (
        <>
          {/* <OfferBanner amount={offersData?.data?.eligibleAmount} /> */}
          {/* <Container> */}
          {!!recommendedOffer && !editOffer && (
            <>
              <RecommendedOffer
                extraFees={{
                  processingFee: offersData?.data?.processingFee,
                  techDocumentationFee: offersData?.data?.techDocumentationFee,
                }}
                recommendedOffer={recommendedOffer}
                handleEditOffer={handleEditOffer}
              />
              {offersData?.data?.bre2Popup ? (
                <UnlockOfferBanner handleUnlock={() => handleUnlockNow()} />
              ) : (
                offersData?.data?.topUpOffer && (
                  <UpgradeOfferUpto7
                    handleContinueWithUpgrade={handleContinueWithUpgrade}
                  />
                )
              )}
              <InsurancePlan
                offerReminder={offerReminder}
                handleLimitedOfferModal={handleLimitedOfferModal}
                handleContinueWithInsurance={proceedWithSelection}
                handleContinueWithoutInsurance={handleContinueWithoutInsurance}
              />
              {/* <UpgradeOfferPopup
                open={openUpgradeOffer}
                handleModal={() => setOpenUpgradeOffer(false)}
                handleContinueWithUpgrade={handleContinueWithUpgrade}
              /> */}
            </>
          )}
          {/* </Container> */}
        </>
      ) : (
        <>
          <Container>
            {canShowRefresh && (
              <Stack
                justifyContent={"center"}
                spacing={5}
                alignItems={"center"}
              >
                <Image src={IMAGES.noOffer} alt="No Offers Available" />
                <Typography fontSize={{ xs: 16, sm: 18 }}>
                  No Offers Available
                </Typography>
                <Typography>
                  There are no offers to show you right now. Please click
                  refresh.
                </Typography>
                <ButtonComponent type="submit" onClick={refreshbtn}>
                  Refresh My Offer
                </ButtonComponent>
              </Stack>
            )}
          </Container>
        </>
      )}

      <BankVarificationModal
        employmentType={productApplication?.employmentType}
        open={bankValidationModal?.open}
        handleModal={() => setBankValidationModal({ open: false })}
        // attempsLeft={productApplication?.aaPerfiosRetryCount}
        error={bankValidationModal?.error}
        btnOnClick={() => setBankValidationModal({ open: false })}
        showBtn={true}
      />
      <FaceVerificationModal
        data={showModalContent}
        open={showErrorFaceMatchModal}
        closeModal={handleVerificationModalClose}
        handleModal={handleVerificationModalAction}
      />
    </>
  );
};

export default OfferScreen;
